import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { updateAutoCompleteTextViewCount } from "api/autoComplete";
import useRoute from "hooks/useRoute";

const SearchContext = React.createContext();

const { Provider } = SearchContext;

const queryStringParser = (queryString) => {
    return queryString
        .slice(1)
        .split("&")
        .reduce((acc, curr) => {
            const [key, value] = curr.split("=");
            return { ...acc, [key]: decodeURI(value) };
        }, {});
};

const SearchProvider = ({ children }) => {
    const { search: locationSearch, pathname } = useLocation();
    const { search: parsedSearch } = queryStringParser(locationSearch);
    const navigate = useRoute();
    const [searchWord, setSearchWord] = useState("");
    const [childDropDownState, setChildDropDownState] = useState(true);

    useEffect(() => {
        let search = parsedSearch;
        if (!parsedSearch) search = window.localStorage.getItem("searchWord");

        // 오픈이노베이션에서 로그아웃시 함수 실행 하지 않음
        if (
            !search &&
            !pathname.includes("/detail") &&
            !pathname.includes("/openInnovation") &&
            !pathname.includes("/competitor") &&
            !pathname.includes("/overseas")
        ) {
            navigate("/");
        }

        window.localStorage.setItem("searchWord", search);
        setSearchWord(search);
        setChildDropDownState(true);
    }, []);

    // 검색어에서 특수문자 제거
    function escapeRegExp(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    //검색이 발생시 자동검색 종료 : 분리된 컴포넌트들에서 공통으로 사용하기 위함
    const childDropDownDisplay = (state) =>{
        setChildDropDownState(state);
    }

    const search = (searchWord, key) => {
        if (!searchWord) return;
        window.localStorage.setItem("searchWord", searchWord);

        // searchWord 업데이트 후, 페이지 이동 -> 그 페이지에서 검색함
        searchWord = escapeRegExp(searchWord);
        setSearchWord(searchWord);

        // 단어 조회수 업데이트
        updateAutoCompleteTextViewCount(searchWord);

        //검색이 발생시 자동검색 종료 : 시점이 context에서 변경되기에 전역상태에서 상태값을 내려줍니다
        childDropDownDisplay(false);

        // key를 받았으면 key에 해당하는 리스트 페이지로 이동
        if (key && searchWord) {
            if (key === "company") return navigate(`/${key}/list?search=${searchWord}`);
            return navigate(`/${key}?search=${searchWord}`);
        }

        // 랜딩에서 전체로 검색할 때
        if (pathname === "/") return navigate(`/company/list?search=${searchWord}`);

        const paths = pathname.split("/");
        if (paths[1] === "company") return navigate(`/${paths[1]}/list?search=${searchWord}`);
        return navigate(`/${paths[1]}?search=${searchWord}`);
    };

    return <Provider value={{ searchWord, search, setSearchWord, childDropDownState, setChildDropDownState }}>{children}</Provider>;
};

export { SearchContext, SearchProvider };
